import React from "react";
import styled from "@emotion/styled";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
//import colors from "./UiComponent";
import SideBarGroup from "./SideBarGroup";
import StaffContext from "../context/StaffContext";
import { useContext } from "react";
import { useTheme } from "@emotion/react";
import useAuth from "../hooks/useAuth";
const SideBarWrapper = styled("span")((props) => ({
  position: "sticky",
  top: 0,
  left: 0,
  width: props.width,
  height: "100vh",
  backgroundColor: props.theme.palette.background.default,
  color: props.theme.palette.third.main,
  padding: "16px 2px 16px 5px",
  boxShadow: `0px 4px 6px ${props.theme.palette.background.shadow}`,
  // borderRadius: '0px 10px 10px 0px',
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
}));

const LogoContainer = styled.span`
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  span {
    font-size: 34px;
    font-weight: 600;
  }
  margin-left: 10px;
  padding-bottom: 40px;
  border-bottom: 0.5px solid ${(props) => props.palette.third.light};
`;
function SideBar() {
  const theme = useTheme();
  const { state, dispatch } = useContext(StaffContext);
  const width = state.sidebar ? "260px" : "60px";
  const {user}=useAuth();
  const hasOffice=user?.roles?Math.max(...user?.roles)===115:false
  return (
    <SideBarWrapper width={width} palette={theme.palette}>
      <LogoContainer
        onClick={() => {
          dispatch({ type: "collapse_expand" });
        }}
        palette={theme.palette}
      >
        <Avatar src="/images/aastulogo.png" sx={{ width: 32, height: 32 }} />
        {state.sidebar && <span>ASLMS</span>}
      </LogoContainer>
      <SideBarGroup
        content={
          state.office === false || hasOffice===true
            ? [
                {
                  header: "Dashboard",
                  children: [
                    {
                      icon: "home",
                      link: "/",
                      name: "Home",
                      level: [101, 102, 103],
                    },
                    {
                      icon: "science",
                      link: "/researches",
                      name: "Research",
                      level: [104, 105],
                    },
                    {
                      icon: "agreements",
                      link: "/staff_agreements",
                      name: "Agreements",
                      level: [106,107,108,109,110,111],
                    },
                    // {
                    //   icon: "overload",
                    //   link: "/staff_overload",
                    //   name: "Staff Overload",
                    //   level: [106, 107],
                    // },
                    // {
                    //   icon: "part_time",
                    //   link: "/part_time",
                    //   name: "Part-Time",
                    //   level: [108, 109],
                    // },
                    // {
                    //   icon: "extension",
                    //   link: "/extensions",
                    //   name: "Extension Load",
                    //   level: [110, 111],
                    // },
                    {
                      icon: "offering",
                      link: "/offering",
                      name: "Course Preference",
                      level: [112],
                    },
                    {
                      icon: "profile",
                      link: "/setting",
                      name: "Profile Settings",
                      level: [113, 114, 115],
                    },
                  ],
                },
              ]
            : [
                {
                  header: "Activities",
                  children: [
                    {
                      icon: "dashboard",
                      link: "/dashboard",
                      name: "Office Dashboard",
                      level: [900],
                    },
                    {
                      icon: "staff",
                      link: "/staff_management",
                      name: "Staff Management",
                      level: [200],
                    },
                    {
                      icon: "allocate",
                      link: "/courseAssignment",
                      name: "Course Assignments",
                      level: [500],
                    },
                    {
                      icon: "science",
                      link: "/research_management",
                      name: "Research Management",
                      level: [801, 802, 803, 804, 805],
                    },
                    {
                      icon: "course",
                      link: "/course_management",
                      name: "Course Management",
                      level: [
                        301, 302, 303, 304, 305, 306, 350, 351, 352, 352, 353,
                        354, 355,
                      ],
                    },
                    {
                      icon: "role",
                      link: "/roles",
                      name: "Role Management",
                      level: [750],
                    },
                    {
                      icon: "semester",
                      link: "/calendar_management",
                      name: "Calendar Management",
                      level: [400,450,451,452],
                    },
                    {
                      icon: "batch",
                      link: "/batch_management",
                      name: "Batch and Sections",
                      level: [400, 401, 402, 403, 404, 405, 406, 407],
                    },
                    {
                      icon: "office",
                      link: "/office_management",
                      name: "Office Management",
                      level: [700],
                    },
                    {
                      icon: "position",
                      link: "/position_management",
                      name: "Position Management",
                      level: [700],
                    },
                    {
                      icon: "setting",
                      link: "/system_setting",
                      name: "System Settings",
                      level: [1100,1101,1102,1103],
                    },
                    {
                      icon: "log",
                      link: "/log",
                      name: "System Log",
                      level: [1200,1201,1202],
                    },
                  ],
                },
              {
                  header: "Approvals",
                  children: [
                    {
                      icon: "agreements",
                      link: "/office_approval",
                      name: "Agreements",
                      level: [1000,1001,1002],
                    },
                    {
                      icon: "agreement_report",
                      link: "/agreementReport",
                      name: "Reports",
                      level: [1000],
                    },
                    // {
                    //   icon: "overload",
                    //   link: "/staff_overloadOffice",
                    //   name: "Overload",
                    //   level: [1000],
                    // },
                    // {
                    //   icon: "part_time",
                    //   link: "/part_timeOffice",
                    //   name: "Part-Time",
                    //   level: [1001],
                    // },
                    // {
                    //   icon: "extension",
                    //   link: "/extensionsOffice",
                    //   name: "Extension Load",
                    //   level: [1002],
                    // },
                  ],
                },
                {
                  header: "Report",
                  children: [
                    {
                      icon: "staff",
                      link: "/staffReport",
                      name: "Staff Report",
                      level: [601],
                    },
                    {
                      icon: "course",
                      link: "/courseReport",
                      name: "Course Report",
                      level: [602],
                    },
                    {
                      icon: "batch",
                      link: "/batchReport",
                      name: "Batch Report",
                      level: [600],
                    },
                  ],
                },
              ]
        }
      />
    </SideBarWrapper>
  );
}

export default SideBar;
